/**
 * Persistent flag for "Developer mode" — when off, the dashboard hides
 * surfaces that only matter to integrators (API keys, webhooks). The
 * default consumer flow uses Telegram-Init-Data auth + bot DM
 * notifications and never needs to see either.
 *
 * Stored in localStorage (per-device, persists across reloads).
 */

const KEY = "shieldz.developer_mode";

export const isDeveloperMode = (): boolean => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export const setDeveloperMode = (on: boolean): void => {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode etc. */
  }
};
